

export const graphColorCodes = [
  'rgba(76, 175, 80, 1)',   // Green
  'rgba(255, 87, 51, 1)',   // Red-Orange
  'rgba(255, 195, 0, 1)',   // Yellow
  'rgba(33, 150, 243, 1)',  // Blue
  'rgba(155, 89, 182, 1)',  // Purple
  'rgba(233, 30, 99, 1)',   // Pink
  'rgba(0, 188, 212, 1)',   // Cyan
  'rgba(139, 195, 74, 1)',  // Lime
  'rgba(255, 152, 0, 1)',   // Orange
  'rgba(121, 85, 72, 1)'    // Brown
];
